import { useCallback } from 'react'
import { prepareEditTurn } from './helpers/prepareEditTurn'
import { scheduleCompletionUpdate } from './helpers/scheduleCompletionUpdate'

/** @param {object} m @param {ReturnType<typeof import('./useExchangeVersionActions').useExchangeVersionActions>} v */
export function useSendEditVersionAction(m, v) {
  const { chatAbortRef, messagesByThreadId, setMessagesByThreadId } = m
  const {
    getNextQueryVersionIndex,
    setExchangeActiveQueryVersion,
    setExchangeActiveAnswerVersion,
  } = v
  const handleSendEditVersion = useCallback(
    ({ threadId, exchangeId, text }) => {
      const trimmed = String(text ?? '').trim()
      if (!trimmed) return
      const tid = threadId
      chatAbortRef.current?.abort()
      const controller = new AbortController()
      chatAbortRef.current = controller
      const { signal } = controller
      const nextIndex = getNextQueryVersionIndex(tid, exchangeId)
      const messages = messagesByThreadId?.[tid] ?? []
      const turn = prepareEditTurn({ tid, messages, trimmed, exchangeId, nextIndex })
      setMessagesByThreadId((prev) => {
        return { ...prev, [tid]: [...turn.priorMessages, turn.userMsg, turn.pendingAssistant] }
      })
      scheduleCompletionUpdate({
        tid,
        pendingId: turn.pendingId,
        signal,
        setMessagesByThreadId,
        apiMessages: turn.apiMessages,
      })
      setExchangeActiveQueryVersion(exchangeId, nextIndex)
      setExchangeActiveAnswerVersion(exchangeId, 0)
    },
    [getNextQueryVersionIndex, setExchangeActiveAnswerVersion, setExchangeActiveQueryVersion, chatAbortRef, messagesByThreadId, setMessagesByThreadId],
  )
  return { handleSendEditVersion }
}
